module.exports = __webpack_public_path__ + "static/media/home-search.0bd61c13.svg";